import { Link, useLocation } from "react-router-dom";

export const CROSSLIST_LINKS = [
  { to: "/seller/add", label: "Create item" },
  { to: "/seller/crosslist", label: "Inventory" },
  { to: "/seller/crosslist/labels", label: "Labels" },
  { to: "/seller/crosslist/import", label: "Import" },
  { to: "/seller/crosslist/analytics", label: "Analytics" },
  { to: "/seller/crosslist/templates", label: "Template Manager" },
  { to: "/seller/crosslist/export", label: "Export CSV" },
];

export const AUTOMATION_LINKS = [
  { to: "/seller/offers", label: "Send Offers" },
  { to: "/seller/automations/auto-offers", label: "Auto Offers" },
  { to: "/seller/automations/sharing", label: "Marketplace Sharing" },
  { to: "/seller/automations/stale", label: "Stale Listing Warning" },
];

export function crosslistActive(pathname) {
  return pathname.startsWith("/seller/crosslist") || pathname === "/seller/add" || pathname === "/seller/products";
}

export function automationsActive(pathname) {
  return pathname.startsWith("/seller/automations") || pathname === "/seller/offers";
}

export function marketplacesActive(pathname) {
  return pathname.startsWith("/seller/connections") || pathname.startsWith("/seller/extension");
}

function Subnav({ links, testid }) {
  const { pathname } = useLocation();
  return (
    <div className="flex flex-wrap gap-2 mb-8" data-testid={testid}>
      {links.map((l) => {
        const on = pathname === l.to;
        return (
          <Link
            key={l.to}
            to={l.to}
            className={`px-3 py-1.5 text-xs rounded-full border ${
              on ? "bg-aura-accent text-white border-aura-accent" : "border-aura-border text-aura-muted hover:text-aura-ink"
            }`}
          >
            {l.label}
          </Link>
        );
      })}
    </div>
  );
}

export function CrosslistSubnav() {
  return <Subnav links={CROSSLIST_LINKS} testid="crosslist-subnav" />;
}

export function AutomationsSubnav() {
  return <Subnav links={AUTOMATION_LINKS} testid="automations-subnav" />;
}

export function PageIntro({ kicker, title, blurb, actions }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div>
        <div className="text-[11px] tracking-luxe uppercase text-aura-muted mb-2">{kicker}</div>
        <h1 className="text-3xl font-semibold">{title}</h1>
        {blurb ? <p className="text-sm text-aura-muted mt-2 max-w-2xl">{blurb}</p> : null}
      </div>
      {actions ? <div className="flex flex-wrap gap-2">{actions}</div> : null}
    </div>
  );
}
